import { TabItemModel } from './TabItemModel';

export class TabDataModel extends TabItemModel {
  public readonly point: number;

  public constructor(title: string, value: string, point: number, disabled?: boolean) {
    super(value, title, disabled);

    this.point = point;
  }
}
